var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMsgIntIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8422 28.6654C13.8641 30.2156 17.3403 30.6355 20.6444 29.8494C23.9485 29.0634 26.8632 27.123 28.8633 24.3781C30.8633 21.6331 31.8172 18.2641 31.5531 14.878C31.2889 11.492 29.8241 8.31164 27.4225 5.91008C25.021 3.50851 21.8406 2.04367 18.4546 1.77951C15.0685 1.51536 11.6995 2.46926 8.95454 4.46933C6.20959 6.4694 4.26925 9.3841 3.48317 12.6882C2.6971 15.9923 3.11698 19.4685 4.66716 22.4904L1.50049 31.8321L10.8422 28.6654Z",
    stroke: "#EF8028",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsgIntIcon);
export default __webpack_public_path__ + "static/media/msg_int_icon.6d14704c5fa441cd2f81857ae18453ae.svg";
export { ForwardRef as ReactComponent };